import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => {
  return {
    root: {
      backgroundColor: alpha(
        theme.palette.mode === 'dark'
          ? theme.palette.common.white
          : theme.palette.common.black,
        0.05,
      ),
      borderRadius: '12px',
      padding: theme.spacing(3, 4),
      color: theme.palette.text.secondary,

      '& > span > span': {
        color: theme.palette.text.primary,
      },
    },
  };
});
